export default "__VITE_ASSET__7yxc$GrS__"